import React from "react";

const Error = () => {
  return (
    <>
      <h2>Error</h2>
      <h3>PAGE NOT FOUND</h3>
    </>
  );
};

export default Error;
